import classNames from 'classnames';
import { ReactNode } from 'react';

type PopupProps = {
  isOpen: boolean;
  close?: () => void;
  customLayout?: boolean;
  title?: string;
  children?: ReactNode;
  className?: string;
};
export const Popup = ({ isOpen, close, className, customLayout, title, children }: PopupProps) => {
  // tailwind modal
  const closeBackground = (e) => {
    if (e.target === e.currentTarget && close) {
      close();
    }
  };
  return (
    <div className={`fixed inset-0 z-50 overflow-y-auto ${isOpen ? 'block' : 'hidden'}`}>
      <div className="flex min-h-screen items-center justify-center p-4 text-center">
        <div className="fixed inset-0 bg-black opacity-50" onClick={closeBackground} />

        {customLayout && <div className="relative w-full max-w-2xl">{children}</div>}
        <div
          className={classNames(
            'relative w-full rounded-lg bg-[var(--background-color)] shadow-lg',
            className && className?.indexOf('max-w-') < 0 ? 'max-w-2xl' : '',
            className,
          )}
        >
          <div className="p-4">
            {title && <h2 className="text-xl font-bold">{title}</h2>}
            {children}
            {close && (
              <button
                className="absolute right-[12px] top-[12px] mt-2 rounded rounded-full bg-premium-dark px-3 py-1 text-white"
                onClick={close}
              >
                x
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
